/// <reference path="../app-routing.module.ts" />
import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../tools/header.service';
import { IxellAPIService, Roles} from '../tools/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LogInService } from '../tools/login-service';
import { StorageService } from '../tools/storage.service';
import { GoogleAnalyticsService } from '../tools/google-analytics';

@Component({
    selector: 'connection',
    templateUrl: './connection.component.html',
    styleUrls: ['./connection.component.scss']
})

export class ConnectionComponent implements OnInit, OnDestroy {
    
    connectionSub: any;
    currentLanguage: string;
    role: Roles;
    accessToken: string;

    constructor(private apiService: IxellAPIService, private storage: StorageService, private router: Router, private headerService: HeaderService, private logInService: LogInService, private readonly gaService: GoogleAnalyticsService, private route: ActivatedRoute) { }

    ngOnInit(): void {

        this.openLoader();

        //en cas de deconnexion 'actualLanguage' n'est pas réinitialisé
        this.currentLanguage = this.storage.get("actualLanguage");
        if (this.currentLanguage)
            this.headerService.changeLangue(this.currentLanguage);
        else {

            this.currentLanguage = navigator.language.split('-')[0];
            this.storage.set("actualLanguage", this.currentLanguage);
            this.headerService.changeLangue(this.currentLanguage);
        }
        // Met en titre IxellWebLab et met la flèche de retour
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeCanBack(false);

        localStorage.removeItem("cart");
        let storedCart = JSON.parse(localStorage.getItem("cart"));
        this.headerService.changeNbProduct(0);
        this.headerService.changeProducts(JSON.stringify(storedCart));


        //*----------------------------------------------------------------------------------------------------*/console.log(this.route.snapshot.paramMap);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.route.snapshot.paramMap.get('token'));

        //this.accessToken = this.route.snapshot.paramMap.get('token')
        this.accessToken = this.route.snapshot.queryParams['token'];
        //if (!this.accessToken) this.route.snapshot.queryParams['token'];
        ///* ----------------------------------------------------------------------------------------------------*/console.log("ngOnInit() - if (this.accessToken) {");
        if (this.accessToken) {
            ///*----------------------------------------------------------------------------------------------------*/console.log("have token");
            this.logInService.parseToken(this.accessToken);
            this.router.navigate(["/login"]);
        } else {
            ///* ----------------------------------------------------------------------------------------------------*/console.log("ngOnInit() - else - if (this.logInService.haveToken() && this.logInService.haveTokenOAuth() && this.logInService.tokenAndTokenOAuthDifferent())");
            if (this.logInService.haveToken() && this.logInService.haveTokenOAuth() && this.logInService.tokenAndTokenOAuthDifferent()) {
                /* affichage home après connexion */
                this.router.navigate(["home"]);

                //// Si déjà connecté, emmène à Home
                //let role = this.storage.get("role");
                ///* ----------------------------------------------------------------------------------------------------*/console.log(role);
                ///* ----------------------------------------------------------------------------------------------------*/console.log((Number.parseInt(role) & Roles.AdminLacour));
                //if (Number.parseInt(role) & Roles.AdminLacour) {
                //    this.router.navigate(['/adminlacourLicence']);
                //} else {
                //    this.router.navigate(['/home']);
                //}
            } else {
                ///* ----------------------------------------------------------------------------------------------------*/console.log("ngOnInit() - else - else - call this.apiService.loginOAuth()");
                this.connectionSub = this.apiService.loginOAuth().subscribe(async data => {

                    this.closeLoader();

                    ///* ----------------------------------------------------------------------------------------------------*/console.log("ngOnInit() - else - else - subscribe this.apiService.loginOAuth()");
                    ///* ----------------------------------------------------------------------------------------------------*/console.log(data);

                    this.logInService.parseLogIn(data);
                    await this.delay(50);

                    let code: string = sessionStorage.getItem("activationCode");
                    let cartCode: string = sessionStorage.getItem("cartCode");
                    let catalogueCode: string = sessionStorage.getItem("catalogueCode");
                    let adminCode: string = sessionStorage.getItem("adminCode");
                    let adminCodeOrder: string = sessionStorage.getItem("adminCodeOrder");
                    let tokenAccount: string = sessionStorage.getItem("tokenAccount");

                    //var lastPage = this.storage.get("lastPage");
                    //this.storage.remove("lastPage");
                    //if (lastPage && lastPage != undefined && lastPage != "" && lastPage != null) {
                    //    var listLastPage = lastPage.split("/");
                    //    var routeNavigate = listLastPage[listLastPage.length - 1];
                    //    this.router.navigate(['/' + routeNavigate]);
                    //} else
                    if (code != null) {
                        // Vient de l'activation auto de la balance (QR code)
                        this.router.navigate(['/userClientForm/' + code]);
                    } else if (catalogueCode != null) {
                        this.router.navigate(['/catalogue']);
                    } else if (adminCode != null) {
                        this.router.navigate(['/adminlacourLicence']);
                    } else if (adminCodeOrder != null) {
                        this.router.navigate(['/adminlacourCommande']);
                    } else if (tokenAccount != null) {
                        this.router.navigate(['/acceptaccount/' + tokenAccount]);
                    } else if (cartCode != null) {
                        setTimeout(() => {
                            this.router.navigate(['/panier'])
                        }, 50);
                    }
                    else {
                        /* affichage home après connexion - désactivation redirection vers adminlacourLicence car home initialise le sidemenu */
                        //var role = this.storage.get("role");
                        //if (Number.parseInt(role) & Roles.AdminLacour) {
                        //    this.router.navigate(['/adminlacourLicence']);
                        //} else {
                            this.router.navigate(['/home']);
                        //}
                    }

                    if (this.connectionSub != null) this.connectionSub.unsubscribe();
                }, error => {
                    if (this.connectionSub != null) this.connectionSub.unsubscribe();
                });
            }
        }

    }

    ngOnDestroy() {
        if (this.connectionSub != null) this.connectionSub.unsubscribe();
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openLoader
     */
    openLoader() {
        let modal = document.getElementById("loadingModalGlobal");
        modal.style.display = "flex";
        if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeLoader
     */
    closeLoader() {
        let modal = document.getElementById("loadingModalGlobal");
        modal.style.display = "none";
    }

}
